export default __webpack_public_path__ + "static/media/img_16.b6359704.png";